/*
 * File: input-string.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-01-16 12:18:59
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import { BaseInputComponent } from "../core/lib/base-input-component";
import { StringInputType, typeProp } from "./core/input-type-prop";
import { PropInnateSync } from "@root/core/vue-props";

@Component
export default class InputString extends BaseInputComponent {
    @PropInnateSync("value", { type: String, default: null })
    innateValue!: string;

    @Prop(typeProp())
    type!: StringInputType;
}
